import {
  IconButton,
  type IconButtonProminenceVariant,
  type IconButtonSizeVariant,
  type IconButtonStyleVariant,
} from '@hungryroot/ui-kit';
import { Share } from '@hungryroot/ui-kit';

export interface ShareButtonProps {
  onClick: () => void;
  className?: string;
  size?: IconButtonSizeVariant;
  style?: IconButtonStyleVariant;
  prominence?: IconButtonProminenceVariant;
}

export function ShareButton(props: ShareButtonProps) {
  const {
    onClick,
    className,
    size = 'small',
    style = 'inverted',
    prominence = 'primary',
  } = props;
  return (
    <IconButton
      ariaLabel="Share"
      className={className}
      size={size}
      style={style}
      prominence={prominence}
      onClick={onClick}
      icon={<Share />}
    ></IconButton>
  );
}
